// extracted by mini-css-extract-plugin
var _1 = "_adminsAdminDetails-module__form-action-button-disabled";
var _2 = "_adminsAdminDetails-module__loader";
var _3 = "_adminsAdminDetails-module__subcontainer";
export { _1 as "form-action-button-disabled", _2 as "loader", _3 as "subcontainer" }
